import type { QueryClient } from "@tanstack/react-query";
import { panelDayKey } from "../panel/usePanelDay";

export function invalidateStayReservationQueries(
  queryClient: QueryClient,
  clinicId: string,
  checkInDate: string,
) {
  queryClient.invalidateQueries({ queryKey: panelDayKey(clinicId, checkInDate) });
}

export function invalidateStayReservationCoverageQueries(
  queryClient: QueryClient,
  clinicId: string | null,
  reservationId: string,
) {
  queryClient.invalidateQueries({ queryKey: ["stay-reservation-coverage", clinicId, reservationId] });
  queryClient.invalidateQueries({ queryKey: ["stay-comanda", reservationId] });
  queryClient.invalidateQueries({ queryKey: ["stay-schedule", clinicId] });
  queryClient.invalidateQueries({ queryKey: ["daycare-hotel"] });
  queryClient.invalidateQueries({ queryKey: ["stay-plan-contracts"] });
  queryClient.invalidateQueries({ queryKey: ["patient-history-feed"] });
  queryClient.invalidateQueries({ queryKey: ["owner-history-feed"] });
}
